import { createI18n } from "vue3-i18n";
import _ from "lodash";
import en from "./lang/en";
import settings, { isDevelopment } from "../helpers/settings";
import {
  getAvailableLanguageKeys,
  getFallbackLanguageKey,
  normalizeLanguageKey,
} from "../helpers/language";

const cloneLangObj = JSON.parse(JSON.stringify(en));
function iter(obj: any) {
  Object.keys(obj).forEach(function (key) {
    if (obj[key] !== null && typeof obj[key] === "object") {
      iter(obj[key]);
      return;
    }
    if (typeof obj[key] === "string") {
      if (obj[key].length > 40) {
        obj[key] = "▒ ▓ ▒ ▓ ▒ ▓ ▒ ▓ ▒ ▓ ▒ ▓ ▒ ▓ ▒ ▓ ▒ ▓ ▒ ▓ ▒";
      } else if (obj[key].length < 5) {
        obj[key] = "▒▓▒▓";
      } else {
        obj[key] = "▒▓▒▓▒▓▒";
      }
    }
  });
}
iter(cloneLangObj);

const messages: Record<string, any> = {
  en: en,
  false: cloneLangObj,
};

const localeLoaders: Record<string, () => Promise<any>> = Object.fromEntries(
  getAvailableLanguageKeys().map((languageKey) => [
    languageKey,
    languageKey === "en"
      ? async () => ({ default: en })
      : () => import(`./lang/${languageKey}`),
  ])
) as Record<string, () => Promise<any>>;

const loadedLocales = new Set<string>(["en", "false"]);

const i18n = createI18n({
  locale: settings.I18N_DEFAULT_LOCALE,
  messages: messages,
});

function normalizeLocale(locale?: string): string {
  if (String(locale || "").toLowerCase() === "false") {
    return "false";
  }
  return normalizeLanguageKey(locale, getFallbackLanguageKey());
}

export async function ensureLocaleMessages(locale?: string): Promise<void> {
  const normalizedLocale = normalizeLocale(locale);
  if (loadedLocales.has(normalizedLocale)) {
    return;
  }

  const loader = localeLoaders[normalizedLocale];
  if (!loader) {
    return;
  }

  const localeModule = await loader();
  messages[normalizedLocale] = localeModule.default || localeModule;
  loadedLocales.add(normalizedLocale);
}

// Fallback to default locale if not found
const $t = i18n.t;
i18n.t = (key: string, params?: any) => {
  let result = $t(key, params);
  if (!result) {
    const locale = i18n.getLocale();
    // ถ้าเป็น default locale แล้วหาไม่เจอ
    if (locale === settings.I18N_FALLBACK_LOCALE) {
      // แสดง key ใน development mode
      if (isDevelopment() && settings.I18N_SHOW_KEY_IN_DEV) {
        console.warn(`[I18N] Not found value for key: ${key}`);
        // return key;
      }
    } else {
      // Fallback ไปหาในภาษา default
      result = _.get(en, key, "");
      if (result && params && typeof result === "string") {
        result = result.replace(/\{(\w+)\}/g, (match: string, name: string) =>
          params[name] !== undefined ? String(params[name]) : match
        );
      }
    }
  }
  return result;
};

export default i18n;
